module.exports = __webpack_public_path__ + "static/brysonNelsonResumePDF-a5dc7729ad103c22afb75e962e13e1f8.pdf";